import React, { useEffect, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import { Loader2, ArrowRight } from "lucide-react";
import { useSeo, getFaqs, type SiteSettings, type Faq } from "@/lib/publicContent";

export default function FaqPage() {
  const settings = useOutletContext<SiteSettings | null>();
  const [faqs, setFaqs] = useState<Faq[] | null>(null);

  useSeo({
    title: `FAQ — ${settings?.site_name || "Bonker"}`,
    description: "Domande frequenti su tempi, prezzi, materiali e processo di personalizzazione delle sneaker Bonker.",
  });

  useEffect(() => { getFaqs().then(setFaqs).catch(() => setFaqs([])); }, []);

  return (
    <div data-testid="faq-page">
      <header className="max-w-3xl mx-auto px-5 md:px-10 pt-16 md:pt-24 pb-12 text-center">
        <span className="text-xs uppercase tracking-[0.25em] font-bold text-secondary">Hai dubbi?</span>
        <h1 className="font-display font-black text-5xl md:text-6xl tracking-tighter mt-3">Domande frequenti</h1>
        <p className="text-muted-foreground mt-5">Tutto quello che c'è da sapere prima di creare il tuo paio.</p>
      </header>

      <div className="max-w-3xl mx-auto px-5 md:px-10 pb-16">
        {faqs === null ? (
          <div className="flex justify-center py-24"><Loader2 className="h-8 w-8 animate-spin text-primary" /></div>
        ) : faqs.length > 0 ? (
          <div className="divide-y divide-white/10 border-y border-white/10" data-testid="faq-list">
            {faqs.map((f) => (
              <details key={f.id} className="group py-6" data-testid="faq-item">
                <summary className="flex items-center justify-between cursor-pointer list-none font-display font-bold text-lg md:text-xl gap-4">
                  {f.question}
                  <span className="text-secondary text-3xl leading-none shrink-0 group-open:rotate-45 transition-transform">+</span>
                </summary>
                <p className="text-sm md:text-base text-muted-foreground mt-4 leading-relaxed">{f.answer}</p>
              </details>
            ))}
          </div>
        ) : (
          <div className="border border-dashed border-white/15 p-16 text-center" data-testid="faq-empty">
            <p className="font-display font-bold text-2xl mb-2">Nessuna FAQ al momento</p>
            <p className="text-muted-foreground">Scrivimi pure: rispondo volentieri a ogni domanda.</p>
          </div>
        )}
      </div>

      <div className="max-w-3xl mx-auto px-5 md:px-10 pb-24 text-center">
        <p className="text-muted-foreground mb-6">Non hai trovato la risposta?</p>
        <Link to="/contatti" className="inline-flex items-center gap-2 border border-white/20 text-foreground font-bold uppercase tracking-[0.12em] text-sm px-8 py-4 hover:border-secondary hover:text-secondary transition-colors">
          Contattami <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  );
}
